import React from "react";

export const days = [
  {
    linkLabel: (
      <>
        <span className="day-tag">Thursday 10th</span>
      </>
    ),
    date: "Thursday 10th",
    stages: [
      {
        name: "MAIN STAGE",
        acts: [
          {
            name: "THE STICKMEN PROJECT",
            time: "23:00 UTC",
          },
          {
            name: "VLADIMIR CAUCHEMAR",
            time: "22:00 UTC",
          },
          {
            name: "ERIKA KRALL",
            time: "21:00 UTC",
          },
          {
            name: "HANDSHAKING",
            time: "19:00 UTC",
          },
        ],
      },
      {
        name: "SOUNDR",
        acts: [
          {
            name: "IZZY BIZU",
            time: "20:51 UTC",
          },
          {
            name: "LIL YAMAHA",
            time: "20:36 UTC",
          },
          {
            name: "BENJI PATTERSON",
            time: "20:25 UTC",
          },
          {
            name: "SHELF LIVES",
            time: "20:03 UTC",
          },
          {
            name: "ADS",
            time: "20:00 UTC",
          },
          {
            name: "IZZY BIZU",
            time: "12:51 UTC",
          },
          {
            name: "LIL YAMAHA",
            time: "12:36 UTC",
          },
          {
            name: "BENJI PATTERSON",
            time: "12:25 UTC",
          },
          {
            name: "SHELF LIVES",
            time: "12:03 UTC",
          },
          {
            name: "ADS",
            time: "12:00 UTC",
          },
        ],
      },
      {
        name: "Meta Tokyo",
        acts: [
          {
            name: "MISOSHITA",
            time: "14:00 UTC",
          },
        ],
      },
      {
        name: "Limewire",
        acts: [
          {
            name: "QUINCY",
            time: "23:47 UTC",
          },
          {
            name: "MAIA WRIGHT",
            time: "23:27 UTC",
          },
          {
            name: "DRU OLIVER",
            time: "23:03 UTC",
          },
          {
            name: "CHARLES JR.",
            time: "23:00 UTC",
          },
          {
            name: "QUINCY",
            time: "18:47 UTC",
          },
          {
            name: "MAIA WRIGHT",
            time: "18:27 UTC",
          },
          {
            name: "DRU OLIVER",
            time: "18:03 UTC",
          },
          {
            name: "CHARLES JR.",
            time: "18:00 UTC",
          },
        ],
      },
      {
        name: "OZZFEST",
        acts: [
          {
            name: "OZZY OSBOURNE",
            time: "00:00 UTC",
          },
          {
            name: "MEGADETH",
            time: "23:00 UTC",
          },
          {
            name: "SKID ROW",
            time: "22:00 UTC",
          },
          {
            name: "BLACK LABEL SOCIETY",
            time: "21:00 UTC",
          },
          {
            name: "RAVEN AGE",
            time: "20:00 UTC",
          },
          {
            name: "BRITOF",
            time: "19:00 UTC",
          },
        ],
      },
      {
        name: "OVER",
        acts: [
          {
            name: "AZEL",
            time: "17:00 UTC",
          },
          {
            name: "DAN: ROS",
            time: "14:00 UTC",
          },
        ],
      },

      {
        name: "RANDOM RAVERS",
        acts: [
          {
            name: "MAI LAWSON",
            time: "00:00 UTC",
          },
          {
            name: "GLÜCK",
            time: "22:30 UTC ",
          },
          {
            name: "LOLU MENAYED",
            time: "21:00 UTC",
          },
          {
            name: "SOUND PROCESS",
            time: "19:30 UTC",
          },
          {
            name: "NACHO VARELA & CRUZ VITTOR",
            time: "18:00 UTC",
          },
        ],
      },
      {
        name: "Party Degenerates",
        acts: [
          {
            name: "GRAMATIK + LUXAS",
            time: "23:00 UTC",
          },
          {
            name: "NOTED",
            time: "20:00 UTC",
          },
        ],
      },
      {
        name: "JERRY GARCIA",
        acts: [
          {
            name: "MICHELE STODDART",
            time: "21:00 UTC",
          },
          {
            name: "LOUIE BRENNAN",
            time: "20:00 UTC",
          },
          {
            name: "COUNTERS CREEK",
            time: "19:00 UTC",
          },
          {
            name: "KITCHMAN SCHMIDT",
            time: "18:00 UTC",
          },
          {
            name: "STOMPING DAVE",
            time: "17:00 UTC",
          },
          {
            name: "MA POLAINE",
            time: "16:00 UTC",
          },
        ],
      },
      {
        name: "JAZZ CLUB",
        acts: [
          {
            name: "ALFIE JAZZ VIDEOS",
            time: "01:00 UTC",
          },
        ],
      },
      {
        name: "OG COMMUNITY STAGE",
        acts: [
          {
            name: "HARRISON FIRST",
            time: "00:00 UTC",
          },
          {
            name: "TRU CLUB",
            time: "23:00 UTC",
          },
          {
            name: "GLITCH CANDIES",
            time: "22:30 UTC",
          },
          {
            name: "CROMULON",
            time: "22:00 UTC",
          },
          {
            name: "SHARK",
            time: "21:30 UTC",
          },
          {
            name: "MARCOS NAIDE",
            time: "21:00 UTC",
          },
        ],
      },
      {
        name: "DILLON FRANCIS",
        acts: [
          {
            name: "DILLON FRANCIS",
            time: "ALL DAY",
          },
        ],
      },
      {
        name: "CASA AZUL STAGE",
        acts: [
          {
            name: "THE GLOBO COLLECTIVE",
            time: "ALL DAY",
          },
          {
            name: "JOW",
            time: "ALL DAY",
          },
          {
            name: "THAMES HOUSE ORCESTRA",
            time: "ALL DAY",
          },
        ],
      },
      {
        name: "Techno Stage",
        acts: [
          {
            name: "YOTAM AVNI",
            time: "02:00 UTC",
          },
          {
            name: "ZEIA",
            time: "01:00 UTC",
          },
          {
            name: "ENDORPHIN",
            time: "00:00 UTC",
          },
          {
            name: "VINCENZO",
            time: "23:00 UTC",
          },
        ],
      },
      {
        name: "TRU BAND",
        acts: [
          {
            name: "SHONTELLE",
            time: "23:00 UTC",
          },
          {
            name: "PAT DIMITRI",
            time: "22:00 UTC ",
          },
          {
            name: "BUFALO",
            time: "20:00 UTC",
          },
          {
            name: "ASH ORPHAN",
            time: "18:00 UTC",
          },
        ],
      },
    ],
  },
  {
    linkLabel: (
      <>
        <span className="day-tag">Friday 11th</span>
      </>
    ),
    date: "Friday 11th",
    stages: [
      {
        name: "MAIN STAGE",
        acts: [
          {
            name: "BRELAND",
            time: "23:00 UTC",
          },
          {
            name: "SPOTTIE WIFI",
            time: "22:00 UTC",
          },
          {
            name: "AMADIS AND THE AMBASSADORS",
            time: "21:00 UTC",
          },
          {
            name: "MAIJA KAUHANEN",
            time: "19:00 UTC",
          },
        ],
      },
      {
        name: "SOUNDR",
        acts: [
          {
            name: "IZZY BIZU",
            time: "02:51 UTC",
          },
          {
            name: "LIL YAMAHA",
            time: "02:36 UTC",
          },
          {
            name: "BENJI PATERSON",
            time: "02:25 UTC",
          },
          {
            name: "SHELF LIVES",
            time: "02:03 UTC",
          },
          {
            name: "ADS",
            time: "02:00 UTC",
          },

          {
            name: "JUNIOR ANDRE",
            time: "20:52 UTC",
          },
          {
            name: "LOEK",
            time: "20:19 UTC",
          },
          {
            name: "SKULLZ",
            time: "20:19 UTC",
          },
          {
            name: "THE TYNE",
            time: "20:03 UTC",
          },
          {
            name: "ADS",
            time: "20:00 UTC",
          },
        ],
      },
      {
        name: "Meta Tokyo",
        acts: [
          {
            name: "ASA WU",
            time: "14:00 UTC",
          },
        ],
      },
      {
        name: "Limewire",
        acts: [
          {
            name: "QUINCY",
            time: "02:47 UTC",
          },
          {
            name: "MAIA WRIGHT",
            time: "02:27 UTC",
          },
          {
            name: "DRU OLIVER",
            time: "02:03 UTC",
          },
          {
            name: "CHARLES JR.",
            time: "02:00 UTC",
          },
          {
            name: "QUINCY",
            time: "18:47 UTC",
          },
          {
            name: "MAIA WRIGHT",
            time: "18:27 UTC",
          },
          {
            name: "DRU OLIVER",
            time: "18:03 UTC",
          },
          {
            name: "CHARLES JR.",
            time: "18:00 UTC",
          },
          {
            name: "BILLYRACXX",
            time: "23:37 UTC",
          },
          {
            name: "LIL BITCOIN",
            time: "23:19 UTC",
          },
          {
            name: "HIGH TIDES",
            time: "23:00 UTC",
          },
          {
            name: "SOULJA BOY",
            time: "19:00 UTC",
          },
          {
            name: "BILLYRACXX",
            time: "18:37 UTC",
          },
          {
            name: "LIL BITCOIN",
            time: "18:19 UTC",
          },
          {
            name: "HIGH TIDES",
            time: "18:00 UTC",
          },
        ],
      },
      {
        name: "OZZFEST",
        acts: [
          {
            name: "MOTORHEAD",
            time: "00:00 UTC",
          },
          {
            name: "RAVEN AGE",
            time: "23:00 UTC",
          },
          {
            name: "SKID ROW",
            time: "22:00 UTC",
          },
          {
            name: "BRITOF",
            time: "18:00 UTC",
          },
        ],
      },
      {
        name: "OVER",
        acts: [
          {
            name: "JAMIS",
            time: "17:00 UTC",
          },
        ],
      },
      {
        name: "RANDOM RAVERS",
        acts: [
          {
            name: "UNTZ KING",
            time: "20:30 UTC",
          },
          {
            name: "MERIO BRAS",
            time: "19:45 UTC ",
          },
          {
            name: "0XPET3R",
            time: "19:00 UTC",
          },
        ],
      },
      {
        name: "Party Degenerates",
        acts: [
          {
            name: "DISCO BISCUITS",
            time: "01:30 UTC",
          },
          {
            name: "KINGSTARLIGHT",
            time: "00:20 UTC",
          },
          {
            name: "SALEM ILESE",
            time: "00:00 UTC",
          },
          {
            name: "BONNIE & CLYDE",
            time: "21:30 UTC",
          },
          {
            name: "LUM feat. MADS PAIGE",
            time: "20:00 UTC",
          },
        ],
      },
      {
        name: "KRAKEN AFTER PARTY",
        acts: [
          {
            name: "HARRISON FIRST",
            time: "23:40 UTC",
          },
        ],
      },
      {
        name: "JERRY GARCIA",
        acts: [
          {
            name: "OUR MAN IN THE FIELD",
            time: "21:00 UTC",
          },
          {
            name: "JACK HARRIS",
            time: "20:00 UTC",
          },
          {
            name: "ROB CORCORAN",
            time: "19:00 UTC",
          },
          {
            name: "JAMES RILEY",
            time: "18:00 UTC",
          },
          {
            name: "DRAIN AND FARRIS",
            time: "17:00 UTC",
          },
          {
            name: "BUFFOS WAKE",
            time: "16:00 UTC",
          },
        ],
      },
      {
        name: "JAZZ CLUB",
        acts: [
          {
            name: "ANETA WARDELL",
            time: "01:00 UTC",
          },
        ],
      },
      {
        name: "OG COMMUNITY STAGE",
        acts: [
          {
            name: "ECLECTIC METHOD",
            time: "23:00 UTC",
          },
          {
            name: "ALP",
            time: "22:30 UTC",
          },
          {
            name: "BUFALO",
            time: "22:00 UTC",
          },
          {
            name: "STONEY EYE",
            time: "21:30 UTC",
          },
          {
            name: "GUCCI TOE",
            time: "21:00 UTC",
          },
        ],
      },
      {
        name: "DILLON FRANCIS",
        acts: [
          {
            name: "DILLON FRANCIS",
            time: "ALL DAY",
          },
        ],
      },
      {
        name: "CASA AZUL STAGE",
        acts: [
          {
            name: "DESTA FRENCH",
            time: "ALL DAY",
          },
          {
            name: "GABRIEL MORENO",
            time: "ALL DAY",
          },
          {
            name: "DGSOLARIS JEREMY TUPLIN",
            time: "ALL DAY",
          },
        ],
      },
      {
        name: "Techno Stage",
        acts: [
          {
            name: "OMER BAR",
            time: "02:00 UTC",
          },
          {
            name: "KADOSH",
            time: "01:00 UTC",
          },
          {
            name: "ALIENTRAK",
            time: "00:00 UTC",
          },
          {
            name: "AIWASKA",
            time: "23:00 UTC",
          },
        ],
      },
      {
        name: "TRU BAND",
        acts: [
          {
            name: "DOMINO",
            time: "02:00 UTC",
          },
          {
            name: "CROMULON",
            time: "00:00 UTC ",
          },
          {
            name: "AMBIENFT",
            time: "19:00 UTC",
          },
          {
            name: "NIFTY SAX",
            time: "18:00 UTC",
          },
          {
            name: "PHUTURE",
            time: "17:00 UTC",
          },
        ],
      },
    ],
  },
  {
    linkLabel: (
      <>
        <span className="day-tag">Saturday 12th</span>
      </>
    ),
    date: "Saturday 12th",
    stages: [
      {
        name: "MAIN STAGE",
        acts: [
          {
            name: "AKIRA THE DON",
            time: "23:00 UTC",
          },
          {
            name: "SOZI",
            time: "22:00 UTC",
          },
          {
            name: "2AM + PIP",
            time: "21:00 UTC",
          },
          {
            name: "ATARASHII GAKKO ",
            time: "12:00 UTC",
          },
        ],
      },
      {
        name: "SOUNDR",
        acts: [
          {
            name: "JUNIOR ANDRE",
            time: "02:52 UTC",
          },
          {
            name: "LOEK",
            time: "02:28 UTC",
          },
          {
            name: "SKULLZ",
            time: "02:19 UTC",
          },
          {
            name: "THE TYNE",
            time: "02:03 UTC",
          },
          {
            name: "ADS",
            time: "02:00 UTC",
          },

          {
            name: "ELLYSE MASON",
            time: "21:04 UTC",
          },
          {
            name: "MIYA MIYA",
            time: "20:49 UTC",
          },
          {
            name: "AMITEK",
            time: "20:20 UTC",
          },
          {
            name: "HOURGLVSS",
            time: "20:03 UTC",
          },
          {
            name: "ADS",
            time: "20:00 UTC",
          },

          {
            name: "ELLYSE MASON",
            time: "13:04 UTC",
          },
          {
            name: "MIYA MIYA",
            time: "12:49 UTC",
          },
          {
            name: "AMITEK",
            time: "12:20 UTC",
          },
          {
            name: "HOURGLVSS",
            time: "12:03 UTC",
          },
          {
            name: "ADS",
            time: "12:00 UTC",
          },
        ],
      },
      {
        name: "META TOKYO",
        acts: [
          {
            name: "KYARY PAMYU PAMYU",
            time: "14:00 UTC"
          }
        ],
      },
      {
        name: "Limewire",
        acts: [
          {
            name: "SOULJA BOY",
            time: "03:00 UTC",
          },
          {
            name: "BILLYRACXX",
            time: "02:37 UTC",
          },
          {
            name: "LIL BITCOIN",
            time: "02:19 UTC",
          },
          {
            name: "HIGH TIDES",
            time: "02:00 UTC",
          },
          {
            name: "SOULJA BOY",
            time: "00:00 UTC",
          },
          {
            name: "ELIJAH BLAKE",
            time: "23:54 UTC",
          },
          {
            name: "ESCAPE PLAN",
            time: "23:23 UTC",
          },
          {
            name: "ORRIN",
            time: "23:02 UTC",
          },
          {
            name: "KOSHA DILLZ",
            time: "23:00 UTC",
          },
          {
            name: "ELIJAH BLAKE",
            time: "18:54 UTC",
          },
          {
            name: "ORRIN",
            time: "18:02 UTC",
          },
          {
            name: "KOSHA DILLZ",
            time: "18:00 UTC",
          },
        ],
      },
      {
        name: "OZZFEST",
        acts: [
          {
            name: "OZZY OSBOURNE",
            time: "00:00 UTC",
          },
          {
            name: "MOTORHEAD",
            time: "23:00 UTC",
          },
          {
            name: "MEGADETH",
            time: "22 UTC",
          },
          {
            name: "BLACK LABEL SOCIETY",
            time: "21 UTC",
          },
          {
            name: "BRITOF",
            time: "20:00 UTC",
          },
        ],
      },
      {
        name: "OVER",
        acts: [
          {
            name: "NICOLA FASANO",
            time: "17:00 UTC",
          },
        ],
      },
      {
        name: "RANDOM RAVERS",
        acts: [
          {
            name: "DEAD TONES",
            time: "23:30 UTC",
          },
          {
            name: "KANA HISHIYA",
            time: "22 UTC ",
          },
          {
            name: "RAMY MISHRIKY",
            time: "20:30 UTC",
          },
          {
            name: "ARIVI",
            time: "19:00 UTC",
          },
        ],
      },
      {
        name: "PARTY DEGENERATES",
        acts: [
          {
            name: "UNDERHER",
            time: "07:00 UTC",
          },
          {
            name: "SANTIAGO GARCIA",
            time: "06:00 UTC",
          },
          {
            name: "PAOLO ROCCO",
            time: "05:00 UTC",
          },
          {
            name: "WAHM",
            time: "04:00 UTC",
          },
          {
            name: "DOMINO",
            time: "03:30 UTC",
          },
          {
            name: "DJ BROWNIE",
            time: "02:00 UTC",
          },
          {
            name: "JASMIN SOLANO",
            time: "01:00 UTC",
          },
          {
            name: "ARAPU",
            time: "00:00 UTC",
          },
          {
            name: "X&ND (SPECIAL LIVESET PERFORMANCE)",
            time: "23:15 UTC",
          },
          {
            name: "ANTARES b2b AURIC b2b BALZAR",
            time: "22:00 UTC",
          },
          {
            name: "HAVOQ",
            time: "21:30 UTC",
          },
          {
            name: "JEFFREY SUTORIUS",
            time: "21:00 UTC",
          },
          {
            name: "DASTIC",
            time: "20:30 UTC",
          },
          {
            name: "VINNE",
            time: "20:00 UTC",
          },
          {
            name: "PLASTIK FUNK",
            time: "19:00 UTC",
          },
          {
            name: "DEFEX",
            time: "18:00 UTC",
          },
        ],
      },
      {
        name: "JERRY GARCIA",
        acts: [
          {
            name: "LIVE RAINBOW FULL OF SOUND",
            time: "00:00 UTC",
          },
          {
            name: "FIONA BEVAN",
            time: "21:00 UTC",
          },
          {
            name: "SMITH AND BREWER",
            time: "20:00 UTC",
          },
          {
            name: "SOPHIE CRAWFORD",
            time: "19:00 UTC",
          },
          {
            name: "MAZ O'CONNOR",
            time: "18:00 UTC",
          },
          {
            name: "TRUCKSTOP HONEYMOON",
            time: "17:00 UTC",
          },
          {
            name: "HANNAH NICHOLSON",
            time: "16:00 UTC",
          },
        ],
      },
      {
        name: "JAZZ CLUB",
        acts: [
          {
            name: "ELIANE CORREA",
            time: "01:00 UTC",
          },
        ],
      },
      {
        name: "OG COMMUNITY STAGE",
        acts: [
          {
            name: "SERENA ELIS",
            time: "00:00 UTC",
          },
          {
            name: "AMBIE NFT",
            time: "23:00 UTC",
          },
          {
            name: "BOBBY YAPS",
            time: "22:30 UTC",
          },
          {
            name: "ELYSE",
            time: "22:00 UTC",
          },
          {
            name: "MARTY GERBS",
            time: "21:30 UTC",
          },
          {
            name: "LEO PASTEL",
            time: "21:00  UTC",
          },
        ],
      },
      {
        name: "DILLON FRANCIS",
        acts: [
          {
            name: "DILLON FRANCIS",
            time: "ALL DAY",
          },
        ],
      },
      {
        name: "CASA AZUL STAGE",
        acts: [
          {
            name: "BALKAN HOT CLUB",
            time: "ALL DAY",
          },
          {
            name: "STEPHANIE SANTIAGO",
            time: "ALL DAY",
          },
          {
            name: "CHRISTALIS VELASCO",
            time: "ALL DAY",
          },
        ],
      },
      {
        name: "Techno Stage",
        acts: [
          {
            name: "ODEUM MUSIC - KIEV",
            time: "02:00",
          },
          {
            name: "ALEV TAV - KIEV",
            time: "01:00",
          },
          {
            name: "DEEPME",
            time: "00:00",
          },
          {
            name: "ARMINA",
            time: "23:00",
          },
        ],
      },
      {
        name: "TRU BAND",
        acts: [
          {
            name: "THE MUSICAL DOC",
            time: "03:00 UTC",
          },
          {
            name: "STONEY + KROOKED TREEZ",
            time: "02:00 UTC ",
          },
          {
            name: "THE PERRIS",
            time: "00:00 UTC",
          },
          {
            name: "JOHNY TIGER",
            time: "22:00 UTC",
          },
          {
            name: "TOM TARNO",
            time: "21:00 UTC",
          },
          {
            name: "MR. SWE",
            time: "20:00 UTC",
          },
          {
            name: "MARCOS NAIDE",
            time: "19:00 UTC",
          },
          {
            name: "JENNIFER RABHA",
            time: "15:00 UTC",
          },
          {
            name: "KR",
            time: "14:30 UTC",
          },
          {
            name: "GEMMI",
            time: "14:00 UTC",
          },
        ],
      },
    ],
  },
  {
    linkLabel: (
      <>
        <span className="day-tag">Sunday 13th</span>
      </>
    ),
    date: "Sunday 13th",
    stages: [
      {
        name: "MAIN STAGE",
        acts: [
          {
            name: "BJÖRK",
            time: "23:00 UTC",
          },
          {
            name: "LOSERS",
            time: "22:00 UTC",
          },
          {
            name: "LIAN GOLD",
            time: "21:00 UTC",
          },
          {
            name: "SNH48",
            time: "12:00 UTC",
          },
        ],
      },
      {
        name: "SOUNDR",
        acts: [
          {
            name: "ELLYSE MASON",
            time: "03:04 UTC",
          },
          {
            name: "MIYA MIYA",
            time: "02:49 UTC",
          },
          {
            name: "AMITEK",
            time: "02:20 UTC",
          },
          {
            name: "HOURGLVSS",
            time: "02:03 UTC",
          },
          {
            name: "ADS",
            time: "02:00 UTC",
          },

          {
            name: "TARUNE",
            time: "20:49 UTC",
          },
          {
            name: "PORTEOUS",
            time: "20:20 UTC",
          },
          {
            name: "HARRISON FIRST",
            time: "20:03 UTC",
          },
          {
            name: "ADS",
            time: "20:00 UTC",
          },

          {
            name: "TARUNE",
            time: "12:49 UTC",
          },
          {
            name: "PORTEOUS",
            time: "12:20 UTC",
          },
          {
            name: "HARRISON FIRST",
            time: "12:03 UTC",
          },
          {
            name: "ADS",
            time: "12:00 UTC",
          },
        ],
      },
      {
        name: "Meta Tokyo",
        acts: [
          {
            name: "EDO LENA",
            time: "14:00 UTC",
          },
        ],
      },
      {
        name: "Limewire",
        acts: [
          {
            name: "ELIJAH BLAKE",
            time: "02:54 UTC",
          },
          {
            name: "ESCAPE PLAN",
            time: "02:23 UTC",
          },
          {
            name: "ORRIN",
            time: "02:02 UTC",
          },
          {
            name: "KOSHA DILLZ",
            time: "02:00 UTC",
          },

          {
            name: "HOMERO GALLARDO",
            time: "23:49 UTC",
          },
          {
            name: "AIMA VITTORI",
            time: "23:06 UTC",
          },
          {
            name: "BXB LOVE",
            time: "23:02 UTC",
          },
          {
            name: "A$AP TYY",
            time: "19:10 UTC",
          },
          {
            name: "HOMERO GALLARDO",
            time: "18:49 UTC",
          },
          {
            name: "AIMA VITTORI",
            time: "18:06 UTC",
          },
          {
            name: "BXB LOVE",
            time: "18:02 UTC",
          },
        ],
      },
      {
        name: "OZZFEST",
        acts: [
          {
            name: "OZZY OSBOURNE",
            time: "00:00 UTC",
          },
          {
            name: "MEGADETH",
            time: "23:00 UTC",
          },
          {
            name: "MOTORHEAD",
            time: "22:00 UTC",
          },
          {
            name: "SKID ROW",
            time: "21:00 UTC",
          },
          {
            name: "BLACK LABEL SOCIETY",
            time: "20:00 UTC",
          },
          {
            name: "RAVEN AGE",
            time: "19:00 UTC",
          },
          {
            name: "BRITOF",
            time: "18:00 UTC",
          },
        ],
      },
      {
        name: "OVER",
        acts: [
          {
            name: "DJ REGARD",
            time: "17:00 UTC",
          },
        ],
      },
      {
        name: "RANDOM RAVERS",
        acts: [
          {
            name: "HERR",
            time: "21:30 UTC",
          },
          {
            name: "IVAN POSEIDON",
            time: "19:50 UTC ",
          },
          {
            name: "DRUNK AT VOGUE",
            time: "18:20 UTC",
          },
          {
            name: "OMVRA",
            time: "17:00 UTC",
          },
        ],
      },
      {
        name: "PARTY DEGENERATES",
        acts: [
          {
            name: "AMINE K",
            time: "02:00 UTC",
          },
          {
            name: "YOKOO",
            time: "01:00 UTC ",
          },
          {
            name: "JOESKI",
            time: "00:00 UTC",
          },
          {
            name: "BLU DETIGER, ADI OASIS & THE KNOCKS",
            time: "21:00 UTC",
          },
          {
            name: "HERMIGERVILL",
            time: "19:30 UTC",
          },
          {
            name: "JONNY OCTOBER",
            time: "19:00 UTC",
          },
          {
            name: "TWO SUNS",
            time: "18:00 UTC",
          },
          {
            name: "KIM APRIL",
            time: "17:00 UTC",
          },
          {
            name: "YAW APPIAH",
            time: "16:00 UTC",
          },
          {
            name: "DANNY VELZ",
            time: "15:30 UTC",
          },
          {
            name: "ALBERTO CENTYMAR",
            time: "14:30 UTC",
          },
          {
            name: "ALMA CILURZO",
            time: "14:00 UTC",
          },
        ],
      },
      {
        name: "JERRY GARCIA",
        acts: [
          {
            name: "PAUL MOSELEY",
            time: "21:00 UTC",
          },
          {
            name: "JAKE MORELY",
            time: "20:00 UTC",
          },
          {
            name: "DJANGO CHUTNEY",
            time: "19:00 UTC",
          },
          {
            name: "LATEMOUTH BLAKE",
            time: "18:00 UTC",
          },
          {
            name: "THE MAGIC LANTERN",
            time: "17:00 UTC",
          },
          {
            name: "CYENFIN",
            time: "16:00 UTC",
          },
        ],
      },
      {
        name: "JAZZ CLUB",
        acts: [
          {
            name: "FLETCHER'S BREW",
            time: "01:00 UTC",
          },
        ],
      },
      {
        name: "OG COMMUNITY STAGE",
        acts: [
          {
            name: "JACK FROST ALIEN DJ",
            time: "00:00 UTC",
          },
          {
            name: "LOUIE C. RHYMES",
            time: "23:00 UTC",
          },
          {
            name: "EMANATE",
            time: "22:30 UTC",
          },
          {
            name: "DAO RECORDS",
            time: "22:00 UTC",
          },
          {
            name: "KANE MAYFIELD",
            time: "21:30 UTC",
          },
          {
            name: "JOSE CABRERAV",
            time: "21:00 UTC",
          },
        ],
      },
      {
        name: "DILLON FRANCIS",
        acts: [
          {
            name: "DILLON FRANCIS",
            time: "ALL DAY",
          },
        ],
      },
      {
        name: "CASA AZUL STAGE",
        acts: [
          {
            name: "ABDOULAYE SAMB",
            time: "ALL DAY",
          },
          {
            name: "THREE CANE WHALE",
            time: "ALL DAY",
          },
          {
            name: "BALLADESTA",
            time: "ALL DAY",
          },
        ],
      },
      {
        name: "TECHNO STAGE",
        acts: [
          {
            name: "DJTRAX",
            time: "02:00 UTC",
          },
          {
            name: "STEVE SAI",
            time: "01:00 UTC",

          },
          {
            name: "MARC ROMBOY",
            time: "00:00 UTC",

          },
          {
            name: "FURIA",
            time: "23:00 UTC",
          },
        ],
      },
      {
        name: "TRU BAND",
        acts: [
          {
            name: "JACK FROST",
            time: "04:00 UTC",
          },
          {
            name: "BLK ORCHID",
            time: "03:00 UTC ",
          },
          {
            name: "BOBBY YAPS",
            time: "02:00 UTC",
          },
          {
            name: "DADA YUTE",
            time: "01:00 UTC",
          },
          {
            name: "F**K BOYS",
            time: "00:00 UTC",
          },
          {
            name: "KEVIN SOUSA & EMILY V",
            time: "21:00 UTC",
          },
          {
            name: "THE HOLLOW LEGS",
            time: "20:00 UTC",
          },
          {
            name: "V TORRES",
            time: "19:00 UTC",
          },
          {
            name: "ZEAL LEVIN",
            time: "18:00 UTC",
          },
          {
            name: "COCONUT SUNDAY",
            time: "17:00 UTC",
          },
          {
            name: "ALMA",
            time: "15:00 UTC",
          },
          {
            name: "X&ND",
            time: "14:00 UTC",
          },
        ],
      },
    ],
  },
];
